(()=>{
  function init(root=document){
    const header=root.querySelector('[data-zp-header]');
    if(header&&!header.dataset.ready){
      header.dataset.ready='1';
      const toggle=header.querySelector('[data-zp-menu]');
      const nav=header.querySelector('.zp-nav');
      const close=()=>{nav.classList.remove('is-open');toggle.setAttribute('aria-expanded','false');};
      toggle.addEventListener('click',()=>{const open=toggle.getAttribute('aria-expanded')!=='true';toggle.setAttribute('aria-expanded',String(open));nav.classList.toggle('is-open',open);});
      nav.addEventListener('click',event=>{if(event.target.closest('a'))close();});
      header.addEventListener('keydown',event=>{if(event.key==='Escape'&&nav.classList.contains('is-open')){close();toggle.focus();}});
      document.addEventListener('click',event=>{if(!header.contains(event.target))close();});
    }
    root.querySelectorAll('.chapter-tabs').forEach(list=>{
      if(list.dataset.ready)return;
      list.dataset.ready='1';
      const tabs=[...list.querySelectorAll('[role=tab]')];
      const activate=tab=>tabs.forEach(item=>{const selected=item===tab;item.setAttribute('aria-selected',String(selected));item.tabIndex=selected?0:-1;const panel=document.getElementById(item.getAttribute('aria-controls'));if(panel)panel.hidden=!selected;});
      tabs.forEach((tab,index)=>{
        tab.addEventListener('click',()=>activate(tab));
        tab.addEventListener('keydown',event=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;event.preventDefault();const next=event.key==='Home'?0:event.key==='End'?tabs.length-1:(index+(event.key==='ArrowRight'?1:tabs.length-1))%tabs.length;activate(tabs[next]);tabs[next].focus();});
      });
    });
    root.querySelectorAll('[data-zp-share]').forEach(container=>{
      const button=container.querySelector('[data-share-button]');
      if(!button||button.dataset.ready||!navigator.clipboard)return;
      button.dataset.ready='1';button.hidden=false;
      button.addEventListener('click',async()=>{const status=container.querySelector('[data-share-status]');try{await navigator.clipboard.writeText(container.dataset.shareUrl);button.textContent=button.dataset.success;status.textContent=button.dataset.success;}catch{status.textContent=button.dataset.error;}});
    });
    root.querySelectorAll('[data-zp-product]').forEach(container=>{
      const select=container.querySelector('[data-product-variant]');
      if(!select||select.dataset.ready)return;
      select.dataset.ready='1';
      select.addEventListener('change',()=>{const option=select.selectedOptions[0];const price=container.querySelector('[data-product-price]');const button=container.querySelector('[data-product-submit]');if(price)price.textContent=option.dataset.price;if(button){const available=option.dataset.available==='true';button.disabled=!available;button.textContent=available?button.dataset.availableLabel:button.dataset.unavailableLabel;}});
    });
  }
  init();
  document.addEventListener('shopify:section:load',()=>init());
})();
